/* eslint-disable import/prefer-default-export */
import { ENV, ENV_ENUM } from '@/shared/config';

const CHECK_CHANGE_ARTIFACT_THUMBNAIL_INTERVAL =
  ENV === ENV_ENUM.customer
    ? 15 * 60 * 1000 // *: 15 minutes
    : 5 * 60 * 1000; // *: 5 minutes

export { CHECK_CHANGE_ARTIFACT_THUMBNAIL_INTERVAL };
